var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192",
    transform: "translate(-849.5 -998.3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_225",
    "data-name": "Rectangle 225",
    width: 17,
    height: 17,
    transform: "translate(849.5 998.3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "plus",
    transform: "translate(849.836 998.836)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_224",
    "data-name": "Rectangle 224",
    width: 16.128,
    height: 16.128,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_16",
    "data-name": "Line 16",
    d: "M3.785-6.975H-7.488A.512.512,0,0,1-8-7.488.512.512,0,0,1-7.488-8H3.785a.512.512,0,0,1,.512.512A.512.512,0,0,1,3.785-6.975Z",
    transform: "translate(10.05 15.417)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_17",
    "data-name": "Line 17",
    d: "M-7.488,4.3A.512.512,0,0,1-8,3.785V-7.488A.512.512,0,0,1-7.488-8a.512.512,0,0,1,.512.512V3.785A.512.512,0,0,1-7.488,4.3Z",
    transform: "translate(15.686 9.781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.7e5811ba9f781faf17650dd3f8ab92f5.svg";
export { ForwardRef as ReactComponent };